// extracted by mini-css-extract-plugin
export var lg = "_e1-7";
export var md = "_e1-6";
export var placeholderContainer = "_e1-1";
export var placeholderIcon = "_e1-2";
export var productImage = "_e1-0";
export var sm = "_e1-5";
export var xl = "_e1-8";
export var xs = "_e1-4";
export var xxs = "_e1-3";